const initialState = {
    // prenameTh: null,
    // nameTh: null,
    // surnameTh: null,
    // prenameEn: null,
    // nameEn: null,
    // surnameEn: null,
    yearNow: null,
    semesterNow: null,
};

import { getField, updateField } from 'vuex-map-fields';
// import UserProvider from "@/services/user.provider.js";
// const userService = new UserProvider();
import RegistrationProvider from "@/services/registration.provider";
const RegistrationService = new RegistrationProvider();

export const registration = {
    namespaced: true,
    state: initialState,
    getters: {
        getField,
    },
    actions: {
        // async getStudentData({ commit }) {
        //     const data = await userService.getStudentData();
        //     commit('set_prenameTh', data.prename_th);
        //     commit('set_nameTh', data.name_th);
        //     commit('set_surnameTh', data.surname_th);
        //     commit('set_prenameEn', data.prename_en);
        //     commit('set_nameEn', data.name_en);
        //     commit('set_surnameEn', data.surname_th);
        // },
        async getYearSemesterNow({ commit }, level_id) {
            const data = await RegistrationService.getYearSemesterNow(level_id)
            commit('setYearNow', data.YEAR);
            commit('setSemesterNow', data.SEMESTER);
        },

    },
    mutations: {
        updateField,
        // set_prenameTh(state, data) { state.prenameTh = data },
        // set_nameTh(state, data) { state.nameTh = data },
        // set_surnameTh(state, data) { state.surnameTh = data },
        // set_prenameEn(state, data) { state.prenameEn = data },
        // set_nameEn(state, data) { state.nameEn = data },
        // set_surnameEn(state, data) { state.surnameEn = data },
        setYearNow(state, data) { state.yearNow = data },
        setSemesterNow(state, data) { state.semesterNow = data },
    },
};